// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**Logo Pre-icfes**/

.ajuste-logo{

    text-align: center;
}

.ajuste-logo>div {
    display: inline-block;
}
/*****/

.hrLogos{
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}

.btn-tipo-2 {
  background-color: #6c757d;
  color: white;
  padding: 10px 20px;
  margin-left: 10px;
  border: none;
  border-radius: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/login-pre-icfes/login-pre-icfes.component.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;;IAEI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;AACA,MAAM;;AAEN;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/**Logo Pre-icfes**/\r\n\r\n.ajuste-logo{\r\n\r\n    text-align: center;\r\n}\r\n\r\n.ajuste-logo>div {\r\n    display: inline-block;\r\n}\r\n/*****/\r\n\r\n.hrLogos{\r\n    margin-top: 10px !important;\r\n    margin-bottom: 10px !important;\r\n}\r\n\r\n.btn-tipo-2 {\r\n  background-color: #6c757d;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  margin-left: 10px;\r\n  border: none;\r\n  border-radius: 1px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
